import VueRouter from 'vue-router'
import BackendProvider from '../services/BackendProvider'

// Views - Pages
import { ROUTES } from '../const'
import Page404 from '../../views/pages/Page404'
import Page500 from '../../views/pages/Page500'
import HomePage from '../../views/pages/HomePage'
import Treatment from '../../views/pages/Treatment'
import FocusedWell from '../../views/pages/FocusedWell'
import PrintWell from '../../views/pages/print/PrintWell'
import HelpCenter from '../../views/pages/HelpCenter'
import PatientShareWelcome from '../../views/pages/patient-share/PatientShareWelcome'
import PatientShareTreatment from '../../views/pages/patient-share/PatientShareTreatment'
import AdminOperations from '../../views/pages/AdminOperations'
import CycleReport from '../../views/pages/print/CycleReport'
import FertReport from '../../views/pages/print/FertReport'
import EmrTreatmentLink from '../../views/pages/EmrTreatmentLink'

// TODO: delete
VueRouter.prototype.update = function (query) {
    const _query = JSON.parse(JSON.stringify(this.currentRoute.query))

    Object.assign(_query, query)

    this.replace({ query: _query })
}

const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'open active',
    history: true,
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        // PATIENT-SHARE
        {
            path: '/patient-share',
            component: PatientShareWelcome,
            name: ROUTES.PATIENT_SHARE_WELCOME,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/patient-share/treatment',
            component: PatientShareTreatment,
            name: ROUTES.PATIENT_SHARE_TREATMENT,
            meta: {
                requiresAuth: false
            }
        },
        // KID-PLUS FOR CLINICS
        {
            path: '/',
            component: HomePage,
            name: ROUTES.HOME_PAGE,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/cycle-report/patients/:patient_id/treatments/:treatment_id',
            component: CycleReport,
            name: ROUTES.CYCLE_REPORT,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/fert-report/patients/:patient_id/treatments/:treatment_id',
            component: FertReport,
            name: ROUTES.FERT_REPORT,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/patients/:patient_id/treatments/:treatment_id',
            component: Treatment,
            name: ROUTES.TREATMENTS,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/print/patients/:patient_id/treatments/:treatment_id/wells/:well_id',
            component: PrintWell,
            name: ROUTES.PRINT_WELL,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/patients/:patient_id/treatments/:treatment_id/wells/:well_id',
            component: FocusedWell,
            name: ROUTES.WELL,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/admin-operations',
            component: AdminOperations,
            name: ROUTES.ADMIN_OPERATIONS,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/emr',
            component: EmrTreatmentLink,
            name: ROUTES.EMR_TREATMENT_LINK_PAGE,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/help-center',
            component: HelpCenter,
            name: ROUTES.HELP_CENTER,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/500',
            name: 'Page500',
            component: Page500,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            name: 'Page404',
            component: Page404,
            meta: {
                requiresAuth: true
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth && !BackendProvider.hasValidToken()) {
        BackendProvider.authenticateUser(to)
    } else {
        next()
    }
})

export default router
